// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previous-games_games-wrapper__0OF-Q {
  padding: 20px;
  background-color: var(--primary-background-color);
  border: 1px solid var(--primary-border-color);
  border-radius: 6px;
}

.previous-games_games-header__0cCET {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.previous-games_subtitle-link__MVuV7 {
  text-decoration: underline;
  cursor: pointer;
}

.previous-games_games-cards__3CRmn {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, 1fr);
}

@media (max-width: 768px) {
  .previous-games_games-cards__3CRmn {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/previous-games.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iDAAiD;EACjD,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".games-wrapper {\n  padding: 20px;\n  background-color: var(--primary-background-color);\n  border: 1px solid var(--primary-border-color);\n  border-radius: 6px;\n}\n\n.games-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.subtitle-link {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.games-cards {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n@media (max-width: 768px) {\n  .games-cards {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"games-wrapper": `previous-games_games-wrapper__0OF-Q`,
	"games-header": `previous-games_games-header__0cCET`,
	"subtitle-link": `previous-games_subtitle-link__MVuV7`,
	"games-cards": `previous-games_games-cards__3CRmn`
};
export default ___CSS_LOADER_EXPORT___;
